var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_1057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3736 12.3946L16.3565 10.4116M11.3992 9.42016L13.3821 7.43723M8.42479 6.44576L10.4077 4.46283M17.348 15.369L19.3309 13.386M21.1156 15.1707C21.3374 15.3917 21.5134 15.6544 21.6335 15.9437C21.7536 16.2329 21.8154 16.543 21.8154 16.8562C21.8154 17.1693 21.7536 17.4794 21.6335 17.7687C21.5134 18.0579 21.3374 18.3206 21.1156 18.5417L18.5377 21.1195C18.3167 21.3413 18.054 21.5173 17.7648 21.6374C17.4755 21.7575 17.1654 21.8193 16.8523 21.8193C16.5391 21.8193 16.229 21.7575 15.9397 21.6374C15.6505 21.5173 15.3878 21.3413 15.1668 21.1195L2.67428 8.62699C2.22867 8.17922 1.97852 7.57321 1.97852 6.9415C1.97852 6.30978 2.22867 5.70377 2.67428 5.256L5.2521 2.67819C5.69987 2.23258 6.30587 1.98242 6.93759 1.98242C7.5693 1.98242 8.17531 2.23258 8.62308 2.67819L21.1156 15.1707Z",
    stroke: "#EAA245",
    strokeWidth: 2.9744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_1057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7952,
    height: 23.7952,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightIcon);
export default __webpack_public_path__ + "static/media/HeightIcon.bbc49b4923c2fdddd9c7bdc673d05415.svg";
export { ForwardRef as ReactComponent };